import { ProcessTag } from "@nens/rana/process-types";
import { objectKeys } from "@nens/shared-utils";

// Hardcoded images for processes, the image shown is decided by process tags.

import BuildingFloodRiskSrc from "@/images/process-building-flood-risk.svg?url";
import CalculateFloorLevelSrc from "@/images/process-calculate-floor-level.svg?url";
import CreateTwoDFloodModelSrc from "@/images/process-create-2d-flood-model.svg?url";
import CreateBasicHydroDataSrc from "@/images/process-create-basic-hydro-data.svg?url";
import ExtractDatasetSrc from "@/images/process-create-extract-dataset.svg?url";
import DefineStudyAreaSrc from "@/images/process-define-study-area.svg?url";
import DelineateBasinsSrc from "@/images/process-delineate-basins.svg?url";
import CalculateDrainagePatternSrc from "@/images/process-drainage-pattern.svg?url";
import RainfallSimulationSrc from "@/images/process-rainfall-simulation.svg?url";
import RainfallStandardEventsSrc from "@/images/process-rainfall-standard-events.svg?url";

const PROCESS_TAG_IMG_MAP: Partial<Record<ProcessTag, string>> = {
  define_study_area: DefineStudyAreaSrc,
  create_basic_hydro_data: CreateBasicHydroDataSrc,
  create_2d_flood_model: CreateTwoDFloodModelSrc,
  simulate_rainfall: RainfallSimulationSrc,
  building_flood_risk: BuildingFloodRiskSrc,
  extract_dataset: ExtractDatasetSrc,
  simulate_rainfall_standard_events: RainfallStandardEventsSrc,
  calculate_floor_level: CalculateFloorLevelSrc,
  calculate_drainage_pattern: CalculateDrainagePatternSrc,
  delineate_basins: DelineateBasinsSrc,
};

export const getProcessImageSrc = (
  tags?: unknown[] /* Strings, but the OpenAPI typing is off */
) => {
  const imageTag = objectKeys(PROCESS_TAG_IMG_MAP).find((tag) => tags?.includes(tag));
  return imageTag ? PROCESS_TAG_IMG_MAP[imageTag] : undefined;
};
